import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import { MdAddCircle } from "react-icons/md";

const Lead = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [openCreateLead, setOpenCreateLead] = useState(false);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [pagination, setPagination] = useState({});

  const clearSearch = () => {
    setSearchQuery("");
  };

  const getAllLeads = (page) => {
    setLoading(true);
    console.log("I am running");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/lead/get-all-lead?page=${page}&limit=${itemsPerPage}&search=${searchQuery}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        console.log("----->", response.data);
        setLeads(response.data.leads);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log("Error in fetching leads: ", leads);
        setLoading(false);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getAllLeads(currentPage);
    }, 500);
    return () => clearTimeout(timeout);
  }, [currentPage, searchQuery]);

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="checkinContainer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Leads
      </h1>

      <div className="p-4 bg-white shadow-lg mt-6 rounded-lg ">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px] mb-2 lg:mt-0 text-primaryTextColor sm:text-[24px] font-bold">
            Leads List
          </h1>
          <div className="relative flex items-center gap-1 lg:gap-2">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

              {searchQuery && (
                <FaTimes
                  onClick={clearSearch}
                  className="absolute right-3 top-3 text-secondaryTextColor cursor-pointer"
                />
              )}
            </div>
            {/* <MdAddCircle
              onClick={() => setOpenCreateLead(true)}
              className="rounded-lg cursor-pointer text-primaryColor"
              size={40}
            /> */}
          </div>
        </div>
        <div className="overflow-x-auto   min-h-[70vh]">
          <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Sl
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Phone
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Type
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Location
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl">
                  Message
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {loading ? (
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-full"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-full"></div>
                    </td>
                  </tr>
                ))
              ) : leads?.length > 0 ? (
                leads.map((lead, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 relative text-sm text-primaryTextColor">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td className="py-4 px-6 relative  text-sm text-primaryTextColor">
                      {lead.name}
                    </td>
                    <td className="py-4 px-6 relative  text-sm text-primaryTextColor">
                      {lead.phone}
                    </td>
                    <td className="py-4 px-6 relative  text-sm text-primaryTextColor">
                      {lead.location}
                    </td>
                    <td className="py-4 px-6 relative  text-sm text-primaryTextColor">
                      {lead.type === "Call"
                        ? "Requesting callback"
                        : "Want to visit"}
                    </td>

                    <td className="py-4 px-6 relative  text-sm text-primaryTextColor">
                      {lead.remarks || "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="py-40 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No Leads available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalLeads)} of{" "}
            {pagination.totalLeads}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lead;
